import { computed } from 'vue'
import type { ReleasesState } from './state'

export const createGetters = (state: ReleasesState) => {
  const filteredReleases = computed(() => {
    let result = [...state.releases]

    // Filter by search
    if (state.filters.search) {
      const search = state.filters.search.toLowerCase()
      result = result.filter(
        (r) =>
          r.name.toLowerCase().includes(search) ||
          r.version.toLowerCase().includes(search) ||
          r.description?.toLowerCase().includes(search) ||
          r.releaseNotes?.toLowerCase().includes(search)
      )
    }

    // Filter by status
    if (state.filters.status) {
      result = result.filter((r) => r.status === state.filters.status)
    }

    // Filter by project
    if (state.filters.projectId) {
      result = result.filter((r) => r.projectId === state.filters.projectId)
    }

    return result
  })

  const plannedReleases = computed(() =>
    state.releases.filter((r) => r.status === 'planned')
  )

  const inProgressReleases = computed(() =>
    state.releases.filter((r) => r.status === 'in_progress')
  )

  const deployedReleases = computed(() =>
    state.releases.filter((r) => r.status === 'deployed')
  )

  const rolledBackReleases = computed(() =>
    state.releases.filter((r) => r.status === 'rolled_back')
  )

  const releasesByProject = computed(() => {
    const grouped: Record<string, typeof state.releases> = {}
    for (const release of state.releases) {
      if (!grouped[release.projectId]) {
        grouped[release.projectId] = []
      }
      grouped[release.projectId].push(release)
    }
    return grouped
  })

  const upcomingReleases = computed(() => {
    const now = new Date()
    return state.releases
      .filter((r) => r.status === 'planned' && r.plannedDate && r.plannedDate > now)
      .sort((a, b) => {
        if (!a.plannedDate || !b.plannedDate) return 0
        return a.plannedDate.getTime() - b.plannedDate.getTime()
      })
  })

  return {
    filteredReleases,
    plannedReleases,
    inProgressReleases,
    deployedReleases,
    rolledBackReleases,
    releasesByProject,
    upcomingReleases,
  }
}
